import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { CoreModule } from '../../core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingCustomComponent } from './loading-custom/loading-custom.component';

@NgModule({
  declarations: [
    LoadingCustomComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NgApexchartsModule,

    TranslateModule,
    TableModule,
    MaterialModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    MultiSelectModule,
    DropdownModule,
    NgbModule,
  ],
  exports: [
    // Component
    LoadingCustomComponent,

    // Module
    RouterModule,
    TranslateModule,
    TableModule,
    MaterialModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    MultiSelectModule,
    DropdownModule,
    NgbModule,
  ],
})
export class IocV2CommonModule { }
